export enum ReservationFeaturesEnum {
    FreeCancellation = 'freeCancellation',
    RealtimeBookingModel = 'realtimeBookingModel',
    WithoutPrepayment = 'withoutPrepayment',
}
